import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { StorageEnum } from '@/enums/storage'
import { ImageCourses } from '@/domain/entities/image-courses.entity'

export const imageCoursesStore = create(
  persist<ImageCoursesStore>(
    (set) => ({
      imageCourses: undefined,
      imagesCourses: undefined,
      setImageCourses: (imageCourses: ImageCourses) => set({ imageCourses }),
      setImagesCourses: (imagesCourses) => set({ imagesCourses }),
    }),
    {
      name: StorageEnum.image_course,
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

type ImageCoursesStore = {
  imageCourses: ImageCourses | undefined
  setImageCourses: (imageCourses: ImageCourses) => void
  imagesCourses: ImageCourses[] | undefined
  setImagesCourses: (imagesCourses: ImageCourses[]) => void
}
